import { createContext } from 'react';

const bloqueadosReservaContext = createContext();

export default bloqueadosReservaContext;
